if (!customElements.get('card-quantity-stepper')) {
  customElements.define(
    'card-quantity-stepper',
    class CardQuantityStepper extends HTMLElement {
      connectedCallback() {
        this.variantId = parseInt(this.dataset.variantId, 10);
        this.quantity = 0;
        this.loading = false;

        if (this.hasAttribute('data-sold-out')) {
          this.renderSoldOut();
        } else {
          this.render();
        }
      }

      renderSoldOut() {
        this.innerHTML = `<div class="card-stepper card-stepper--sold-out">
          <span>${window.variantStrings?.soldOut || 'Agotado'}</span>
        </div>`;
      }

      render() {
        this.innerHTML = `<div class="card-stepper">
          <button class="card-stepper__btn" type="button" aria-label="Quitar"
            ${this.quantity === 0 || this.loading ? 'disabled' : ''}>−</button>
          <span class="card-stepper__qty">${this.loading ? '·' : this.quantity}</span>
          <button class="card-stepper__btn" type="button" aria-label="Agregar"
            ${this.loading ? 'disabled' : ''}>+</button>
        </div>`;

        const [dec, inc] = this.querySelectorAll('.card-stepper__btn');
        dec.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.decrement(); });
        inc.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.increment(); });
      }

      _updateDrawer(data) {
        const cartDrawerEl = document.querySelector('cart-drawer');
        if (!cartDrawerEl) return;

        // Usar renderContents de Dawn si está disponible y tiene sections
        if (typeof cartDrawerEl.renderContents === 'function' && data.sections) {
          cartDrawerEl.renderContents(data);
          return;
        }

        // Fallback: actualizar manualmente
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(cartUrl + '?section_id=cart-drawer')
          .then((r) => r.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newCartDrawer = doc.querySelector('cart-drawer');
            if (newCartDrawer) {
              cartDrawerEl.classList.toggle('is-empty', newCartDrawer.classList.contains('is-empty'));
            }
            const drawerInner = document.querySelector('.drawer__inner');
            const newInner = doc.querySelector('.drawer__inner');
            if (drawerInner && newInner) drawerInner.innerHTML = newInner.innerHTML;
          })
          .catch((e) => console.error('[stepper] fallback refresh error:', e));
      }

      async increment() {
        if (this.loading) return;
        this.loading = true;
        this.render();

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: this.variantId, quantity: 1 }],
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (res.ok && data.items) {
            this.quantity += 1;
            this._updateDrawer(data);
          }
        } catch (e) {
          console.error('[stepper] add error:', e);
        }

        this.loading = false;
        this.render();
        if (window.AlmaCart) window.AlmaCart.fetch();
      }

      async decrement() {
        if (this.loading || this.quantity <= 0) return;
        this.loading = true;
        this.render();

        const newQty = this.quantity - 1;

        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: this.variantId,
              quantity: newQty,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (res.ok && !data.errors) {
            this.quantity = newQty;
            this._updateDrawer(data);
          }
        } catch (e) {
          console.error('[stepper] change error:', e);
        }

        this.loading = false;
        this.render();
        if (window.AlmaCart) window.AlmaCart.fetch();
      }
    }
  );
}
